var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_895_1606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 8.125C15 7.22216 14.8222 6.32817 14.4767 5.49405C14.1312 4.65994 13.6248 3.90204 12.9864 3.26364C12.348 2.62524 11.5901 2.11883 10.7559 1.77333C9.92184 1.42783 9.02784 1.25 8.125 1.25C7.22216 1.25 6.32817 1.42783 5.49405 1.77333C4.65994 2.11883 3.90204 2.62524 3.26364 3.26364C2.62524 3.90204 2.11883 4.65994 1.77333 5.49405C1.42783 6.32817 1.25 7.22216 1.25 8.125C1.25 9.02784 1.42783 9.92184 1.77333 10.7559C2.11883 11.5901 2.62524 12.348 3.26364 12.9864C3.90204 13.6248 4.65994 14.1312 5.49405 14.4767C6.32817 14.8222 7.22216 15 8.125 15C9.02784 15 9.92184 14.8222 10.7559 14.4767C11.5901 14.1312 12.348 13.6248 12.9864 12.9864C13.6248 12.348 14.1312 11.5901 14.4767 10.7559C14.8222 9.92184 15 9.02784 15 8.125ZM13.4102 14.2969C11.9922 15.5156 10.1445 16.25 8.125 16.25C3.63672 16.25 0 12.6133 0 8.125C0 3.63672 3.63672 0 8.125 0C12.6133 0 16.25 3.63672 16.25 8.125C16.25 10.1445 15.5156 11.9922 14.2969 13.4102L19.8164 18.9336C20.0586 19.1758 20.0586 19.5742 19.8164 19.8164C19.5742 20.0586 19.1758 20.0586 18.9336 19.8164L13.4102 14.2969Z",
    fill: "#707070"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_895_1606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.5c6126c18245680ad53e1a592d13e474.svg";
export { ForwardRef as ReactComponent };